module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.e95e0266.jpg";